import { sample } from "./sample";
import { shared } from "./shared";
import { sideMenu } from "./sideMenu";

export const nb = { sample, shared, sideMenu };
